$(document).ready(function() {
    const $inputs = $('.splitinput input');
    const $hiddenCode = $('#id_code');
    const $newRequestBtn = $('.js-2fa-request-new-code');
    const $verifyBtn = $('.js-verify-auth-code');

    // --- 1. UTILITY FUNCTIONS ---

    const updateHiddenCode = () => {
        const fullCode = $inputs.map((_, el) => $(el).val()).get().join('');
        $hiddenCode.val(fullCode);
    };

    const handleAjax = (url, data, successMsg, redirectUrl = null) => {
        $.ajax({
            url: url,
            type: 'POST',
            headers: { 'accept': 'application/json' },
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: function() {
                showToast(`<h4 class="red">${successMsg}</h4><p>Operation successful!</p>`);
                if (redirectUrl) {
                    setTimeout(() => window.location.href = redirectUrl, 800);
                }
            },
            error: function(xhr) {
                console.error('Error:', xhr.responseText);
                showToast(`<h4 class="red">Error</h4><p>Failed! Please try again.</p>`);
            }
        });
    };

    // --- 2. INPUT FIELD LOGIC ---

    $inputs.on('input', function() {
        const $this = $(this);
        let val = $this.val();

        if (val && !/^\d$/.test(val)) {
            $this.val('');
            return;
        }

        if (val) $this.next('input').focus();
        updateHiddenCode();
    });

    $inputs.on('keydown', function(e) {
        if (e.key === 'Backspace' && !$(this).val()) {
            $(this).prev('input').focus();
        }
    });

    $inputs.on('paste', function(e) {
        e.preventDefault();
        const pasteData = (e.originalEvent.clipboardData || window.clipboardData).getData('text');
        const digits = pasteData.replace(/\D/g, '').split('');

        // We still strip non-digits to keep the 2FA code clean
        $inputs.each((i, el) => {
            if (digits[i]) $(el).val(digits[i]);
        });

        // Focus the next empty input or the last one
        const nextIndex = Math.min(digits.length, $inputs.length - 1);
        $inputs.eq(nextIndex).focus();
        updateHiddenCode();
    });

    // --- 3. INITIALIZATION & TIMERS ---

    if ($newRequestBtn.length > 0) {
        // Resolve User ID from URL if missing
        if ($verifyBtn.attr('data-user-id') === 'None') {
            const pathSegments = window.location.pathname.split('/').filter(s => s);
            const userIdFromUrl = pathSegments[pathSegments.length - 1];
            $verifyBtn.attr('data-user-id', userIdFromUrl);
        }

        // Re-enable request button after 2 minutes
        setTimeout(() => $newRequestBtn.removeClass('disabled'), 120000);
    }

    // --- 4. EVENT DELEGATION ---

    $(document)
        .on('click', '.js-open-2fa-confirm', function(e) {
            e.preventDefault();
            $('body').addClass('locked');
            $('.enable_2fa').addClass('open');
        })
        .on('click', '.js-close-2fa-confirm', function(e) {
            e.preventDefault();
            $('body').removeClass('locked');
            $('.enable_2fa').removeClass('open');
        })
        .on('click', '.js-start-auth', function(e) {
            e.preventDefault();
            const userData = { user_id: $(this).data('user-id') };
            const status = $(this).data('auth-status');
            handleAjax('/api/accounts/2fa/request-code', userData, '2FA Request', `/accounts/2fa/${status}`);
        })
        .on('click', '.js-2fa-request-new-code', function(e) {
            e.preventDefault();
            const urlParams = new URLSearchParams(window.location.search);
            const method = urlParams.get('method');
            handleAjax('/api/accounts/2fa/request-code', { user_id: $(this).data('user-id'), channel:  method}, '2FA Code');
            $newRequestBtn.addClass('disabled'); 
            setTimeout(() => $newRequestBtn.removeClass('disabled'), 120000);
        })
        .on('click', '.js-verify-auth-code', function(e) {
            e.preventDefault();
            const codeValue = $hiddenCode.val();
            
            // Validation
            $inputs.removeClass('error');
            const $emptyInputs = $inputs.filter(function() { return !$(this).val(); });

            if ($emptyInputs.length > 0) {
                $emptyInputs.addClass('error').first().focus();
                showToast(`<h4 class="red">Invalid Code</h4><p>Please fill in all digits.</p>`);
                return;
            }

            // Determine API Endpoint and Data
            const isLogin = $(this).hasClass('login_2fa');
            const userId = $(this).data('user-id');
            const authStatus = $(this).data('auth-status');
            
            const url = isLogin ? '/api/accounts/2fa/login' : `/api/accounts/2fa/${authStatus}`;
            const redirect = isLogin ? '/' : '/accounts';
            const payload = isLogin ? { user_id: userId, code: codeValue } : { code: codeValue };

            handleAjax(url, payload, isLogin ? 'Login Successful' : '2FA Code', redirect);
        });
});